import React from 'react'
import PropTypes from 'prop-types'

import { MoreThanBreakpoint } from 'Utils/GetBreakpoint'

class Sticky extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isSticky: false,
      minHeight: 0,
    }

    this.setStickiness = this.setStickiness.bind(this)

    this.stickyBarRef = React.createRef()
  }

  componentDidMount() {
    const stickyBar = this.stickyBarRef.current.getBoundingClientRect()

    this.initialElOffsetTop = stickyBar.top

    this.setState({ minHeight: stickyBar.height })

    window.addEventListener('scroll', this.setStickiness)
  }

  componentDidUpdate() {
    const stickyBar = this.stickyBarRef.current.getBoundingClientRect()

    this.initialElOffsetTop = stickyBar.top
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.setStickiness)
  }

  setStickiness() {
    const stickyBar = this.stickyBarRef.current.getBoundingClientRect()

    this.initialElOffsetTop = stickyBar.top

    if (this.initialElOffsetTop < this.props.stickyOffset) {
      this.setState({ isSticky: true })
    } else {
      this.setState({ isSticky: false })
    }
  }

  render() {
    const className = this.state.isSticky ? `${this.props.className} is-sticky` : this.props.className
    const style = this.state.isSticky ? {
      [this.props.position]: this.props.offset,
      position: 'fixed',
    } : {}

    if (this.props.selfAdjustingWidth) {
      if (this.state.isSticky && MoreThanBreakpoint('xs')) {
        style.width = this.stickyBarRef.current.clientWidth
      } else {
        style.width = '100%'
        style.left = 0
      }
    }

    return (
      <div
        ref={this.stickyBarRef}
        style={{ minHeight: this.state.minHeight }}
        className={this.props.wrapperClassName}
      >
        <div className={className} style={style}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

Sticky.propTypes = {
  className: PropTypes.string,
  offset: PropTypes.number,
  position: PropTypes.string,
  stickyOffset: PropTypes.number,
  selfAdjustingWidth: PropTypes.bool,
  wrapperClassName: PropTypes.string,
}

Sticky.defaultProps = {
  className: '',
  offset: 0,
  position: 'top',
  stickyOffset: 0,
  selfAdjustingWidth: false,
  wrapperClassName: '',
}

export default Sticky
